import { render, staticRenderFns } from "./CompartilharContaHistorico.vue?vue&type=template&id=1e4fad88&scoped=true&"
import script from "./CompartilharContaHistorico.vue?vue&type=script&setup=true&lang=js&"
export * from "./CompartilharContaHistorico.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CompartilharContaHistorico.vue?vue&type=style&index=0&id=1e4fad88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4fad88",
  null
  
)

export default component.exports